import {HeadCell} from "interfaces";

export const headCells: readonly HeadCell[] = [
  {
    id: "code",
    disablePadding: true,
    label: "Código",
  },
  {
    id: "status",
    disablePadding: false,
    label: "Estatus",
  },
  {
    id: "actions",
    disablePadding: false,
    label: "Ver crédito",
  },
];
